<check-in-form-wrapper [ariaLabel]="''" [step]="'step-1'" [showContinue]="false" [showPriceDisplay]="false">
  <div class="form-wrapper-middle-body">
    <change-flight></change-flight>
  </div>
</check-in-form-wrapper>
